import microApp from '@micro-zoe/micro-app'
import { AppProvider } from '@mkmp/core'
import { AuthProvider } from './provider'
import { setApiOptions } from 'mk-biz-pc'
import App from './App'
import './assets/styles/index.scss'
/**
 * 设置api配置
 */
setApiOptions({
  core: process.env.API_CORE_URL,
  admin: process.env.API_ADMIN_URL,
  kbs: process.env.API_KBS_URL,
  prc: process.env.API_PRC_URL,
  report: process.env.API_REPORT_URL
})

// 加载micro-app
microApp.start({
  'router-mode': 'native',
  plugins: {
    global: [
      {
        processHtml: (code: string) => {
          // 将主应用全局变量注入，防止子应用获取不到
          return code.replace(
            '<head>',
            `<head><script>(function(window){
                ['React', 'ReactDOM', 'ReactRouter', 'ReactRouterDOM','RemixRouter', 'axios'].forEach((key) => {
                  window[key] = window.rawWindow[key]
                })
              })(window);</script>`
          )
        }
      }
    ]
  }
})

const root = ((window as any).ReactDOM as unknown as any).createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <AppProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </AppProvider>
)
